import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';

export default function ({ id, type, onClick, rowIndex, colIndex, backgroundColor }) {
    const [hover, setHover] = React.useState(false);

    const getColor = (val, hover) => {
        switch (val) {
            case 'o': return hover ? '#DBF2DF' : backgroundColor ? backgroundColor : '#B7E7C0';
            case 'b': return '#ffd9d7';
            case 's': return '#B7E7C0';
            default: return 'white';
        }
    }

    const canBook = (val) => {
        return val === 'o'
    }

    const getToolTip = (val) => {
        switch (val) {
            case 'o': return 'Open for donation';
            case 'b': return 'Already donated';
            case 's': return 'Selected';
            case 'd': return 'Free space';
            default: return 'white';
        }
    }

    const getTileName = (rowIndex, colIndex) => {
        let letters = ''
        while (rowIndex >= 0) {
            letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[rowIndex % 26] + letters
            rowIndex = Math.floor(rowIndex / 26) - 1
        }

        return `${letters}${colIndex + 1}`;
    }
    return <Tooltip title={`${getTileName(rowIndex, colIndex)} - ${getToolTip(type)}`}>
        <div style={{
            backgroundColor: getColor(type, hover),
            width: '100%',
            paddingTop: '100%',
            position: 'relative',
            cursor: type !== 'd' && 'pointer'
        }}
            onClick={() => { canBook && onClick() }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}>
            <div style={{
                position: 'absolute',
                left: 0,
                bottom: 0,
                right: 0,
                textAlign: 'center',
                top: '50%',
                transform: 'translateY(-50%)'
            }}>
                {
                    type !== 'd' && getTileName(rowIndex, colIndex)
                }
                {
                    type === 'd' && <CloseIcon fontSize={'1vw'} />
                }
            </div>
        </div>
    </Tooltip>;
}